import React from "react";

const InvestmentReportSkeleton = () => {
  return (
    <div className="investment-report">
      {/* Performance Cards Skeleton */}
      <div className="row mb-4"></div>

      {/* Table Skeleton */}
      <div className="card border-0 shadow-sm">
        <div className="card-header bg-transparent border-bottom pt-4 px-4">
          <div
            className="investment-report-skeleton skeleton-text short"
            style={{ height: "20px", width: "150px" }}
          ></div>
        </div>
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead className="table-light">
                <tr>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => (
                    <th key={item} className="border-0 ps-4">
                      <div
                        className="investment-report-skeleton skeleton-text short"
                        style={{ height: "16px", width: "80%" }}
                      ></div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[1, 2, 3, 4, 5].map((row) => (
                  <tr key={row}>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((col) => (
                      <td key={col} className="ps-4">
                        <div
                          className="investment-report-skeleton skeleton-text short"
                          style={{ height: "16px", width: "70%" }}
                        ></div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestmentReportSkeleton;
